<template>
  <v-card shaped>
    <v-system-bar class="d-flex justify-end"><span class="text-h6 ">{{ title }}</span></v-system-bar>
    <v-row dense no-gutters>
      <v-sheet class="d-flex align-center mx-3">
        <slot name="left"></slot>
      </v-sheet>
      <v-sheet>
        <slot name="default">
        </slot>
      </v-sheet>
    </v-row>
  </v-card>
</template>

<script>

export default {
  name: 'BaseCardListBlock',
  inheritAttrs: false,
  props: {
    title: {default: null},
  },

  components: {},

  computed: {
    error() {
      return !!this.property_state && !!this.property_state_field_name && this.property_state[this.property_state_field_name].error
    },
    error_message() {
      if (!!!!this.property_state && !!this.property_state_field_name && this.property_state[this.property_state_field_name].error)
        return this.property_state[this.property_state_field_name].error_message
      else
        return null
    },
  },

  methods: {},

  async mounted() {
  },

  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>
